// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "path[data-v-67f7589b] {\n  fill: currentColor;\n  stroke: currentColor;\n}\nline[data-v-67f7589b] {\n  stroke: currentColor;\n}", ""]);
// Exports
module.exports = exports;
